"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Typography_1 = require("src/components/Typography/Typography");
var TextArea_1 = __importDefault(require("./TextArea"));
var StyledTextArea_1 = require("./StyledTextArea");
var TextArea = (0, TextArea_1.default)((0, Typography_1.makeText)('textarea'));
var TextAreaBox = function (_a) {
    var margin = _a.margin, label = _a.label, message = _a.message, height = _a.height, rest = __rest(_a, ["margin", "label", "message", "height"]);
    return (react_1.default.createElement(StyledTextArea_1.StyledTextAreaContainer, { margin: margin, height: height },
        label && react_1.default.createElement(StyledTextArea_1.StyledLabel, null, label),
        react_1.default.createElement(TextArea, __assign({ messageType: message ? message.type : null }, rest)),
        message && react_1.default.createElement(StyledTextArea_1.StyledMessage, { messageType: message.type }, message.text)));
};
exports.default = TextAreaBox;
